export function findHashes(searchText) {
  if (searchText) {
    const div = document.createElement('div')
    div.innerHTML = searchText?.replaceAll(`<div><br></div>`, '\n')

    const regexp = /\#\w\w+\b/g
    const result = div.textContent.match(regexp);

    if (result) {
        return result
    } else {
        return;
    }
  }
}
